module.exports = __webpack_public_path__ + "static/heroslider2-7bf403fc4fb4ae7d88094ee9d6cd94f9.jpg";